import React from 'react';
import classNames from 'owa-classnames';
import { OWA_TITLE_BAR_ID } from 'owa-header-constants';
import { observer } from 'owa-mobx-react';
import { useComputedValue } from 'owa-react-hooks/lib/useComputed';
import { getCurrentThemeId, getHeaderImageData } from 'owa-theme';
import isFullBleedEnabled from '../utils/isFullBleedEnabled';
import { headerMain, headerFullBleed } from './OwaHeader.scss';

interface OwaHeaderBackgroundProps {
    children: React.ReactNode;
}

export default observer(function OwaHeaderBackground(props: OwaHeaderBackgroundProps) {
    const themeId = getCurrentThemeId();
    const headerImageStyles = useComputedValue(() => {
        const headerImageData = getHeaderImageData(themeId);
        return {
            backgroundImage: headerImageData.BackgroundImageUrl
                ? `url(${headerImageData.BackgroundImageUrl})`
                : 'none',
        };
    }, [themeId]);

    return (
        <div
            id={OWA_TITLE_BAR_ID}
            style={headerImageStyles}
            className={classNames(headerMain, isFullBleedEnabled() && headerFullBleed)}
        >
            {props.children}
        </div>
    );
}, 'OwaHeaderBackground');
